<template>
	<div>
		<!-- Info Saldo dan Saham -->
		<div v-if="accountInfo" class="row justify-content-center mb-4">
			<div class="col-md-12">
				<div class="card border">
					<div class="card-header bg-light">
						<h6 class="mb-0">Rincian yang Akan Dicairkan</h6>
					</div>
					<div class="card-body">
						<div class="table-responsive">
							<table class="table table-sm mb-0">
								<tbody>
									<tr v-if="accountInfo.shares.total_shares > 0">
										<td><strong>Total Saham</strong> ({{ accountInfo.shares.total_shares }} sertifikat) ({{ accountInfo.shares.total_slot }} lot)</td>
										<td class="text-end">{{ formatCurrency(accountInfo.shares.total_amount) }}</td>
									</tr>
									<tr v-if="accountInfo.wallet.has_wallet">
										<td><strong>Saldo Wallet</strong></td>
										<td class="text-end">{{ formatCurrency(accountInfo.wallet.amount) }}</td>
									</tr>
									<tr v-if="accountInfo.wallet.has_wallet">
										<td>Biaya Admin</td>
										<td class="text-end text-danger">- {{ formatCurrency(accountInfo.wallet.admin_fee) }}</td>
									</tr>
									<tr v-if="accountInfo.wallet.has_wallet" class="table-active">
										<td><strong>Total Wallet</strong></td>
										<td class="text-end"><strong>{{ formatCurrency(accountInfo.wallet.total_amount) }}</strong></td>
									</tr>
									<tr class="table-primary">
										<td><strong>Grand Total Pencairan</strong></td>
										<td class="text-end"><strong>{{ formatCurrency(accountInfo.grand_total) }}</strong></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<form @submit.prevent="submitForm">
			<div class="row">
				<div class="col-md-6 mb-3">
					<label for="name" class="form-label">Nama Lengkap <span class="text-danger">*</span></label>
					<input type="text" class="form-control" id="name" v-model="formData.name"
						:class="{ 'is-invalid': errors.name }" disabled required>
					<div v-if="errors.name" class="invalid-feedback">{{ errors.name[0] }}</div>
				</div>

				<div class="col-md-6 mb-3">
					<label for="nik" class="form-label">NIK <span class="text-danger">*</span></label>
					<input type="number" class="form-control" id="nik" v-model="formData.nik"
						:class="{ 'is-invalid': errors.nik }" maxlength="20" disabled required>
					<div v-if="errors.nik" class="invalid-feedback">{{ errors.nik[0] }}</div>
				</div>

				<div class="col-md-12 mb-3">
					<label for="address" class="form-label">Alamat <span class="text-danger">*</span></label>
					<textarea class="form-control" id="address" rows="3" v-model="formData.address"
						:class="{ 'is-invalid': errors.address }" disabled required></textarea>
					<div v-if="errors.address" class="invalid-feedback">{{ errors.address[0] }}</div>
				</div>

				<div class="col-md-6 mb-3">
					<label for="phone_number" class="form-label">Nomor Telepon <span class="text-danger">*</span></label>
					<input type="number" class="form-control" id="phone_number" v-model="formData.phone_number"
						:class="{ 'is-invalid': errors.phone_number }" maxlength="20" required>
					<div v-if="errors.phone_number" class="invalid-feedback">{{ errors.phone_number[0] }}</div>
				</div>

				<div class="col-md-6 mb-3">
					<label for="bank_name" class="form-label">Nama Bank <span class="text-danger">*</span></label>
					<input type="text" class="form-control" id="bank_name" v-model="formData.bank_name"
						:class="{ 'is-invalid': errors.bank_name }" maxlength="100" required>
					<div v-if="errors.bank_name" class="invalid-feedback">{{ errors.bank_name[0] }}</div>
				</div>

				<div class="col-md-6 mb-3">
					<label for="bank_account_number" class="form-label">Nomor Rekening <span class="text-danger">*</span></label>
					<input type="number" class="form-control" id="bank_account_number" v-model="formData.bank_account_number"
						:class="{ 'is-invalid': errors.bank_account_number }" maxlength="50" required>
					<div v-if="errors.bank_account_number" class="invalid-feedback">{{ errors.bank_account_number[0] }}</div>
				</div>

				<div class="col-md-6 mb-3">
					<label for="bank_account_name" class="form-label">Nama Pemilik Rekening <span
							class="text-danger">*</span></label>
					<input type="text" class="form-control" id="bank_account_name" v-model="formData.bank_account_name"
						:class="{ 'is-invalid': errors.bank_account_name }" maxlength="255" required>
					<div v-if="errors.bank_account_name" class="invalid-feedback">{{ errors.bank_account_name[0] }}</div>
				</div>

				<div class="col-md-12 mb-3">
				<label for="ktp_image" class="form-label">
					Upload Foto KTP 
					<span v-if="!isEdit" class="text-danger">*</span>
					<span v-else class="text-muted">(Kosongkan jika tidak ingin mengubah)</span>
				</label>
				<input type="file" class="form-control" id="ktp_image" @change="handleFileChange"
					:class="{ 'is-invalid': errors.ktp_image }" accept="image/jpeg,image/png,image/jpg" :required="!isEdit">
					<div class="form-text">Format: JPG, JPEG, PNG. Ukuran bebas (akan dikompres otomatis)</div>
					<div v-if="errors.ktp_image" class="invalid-feedback">{{ errors.ktp_image[0] }}</div>
					
					<!-- Preview KTP -->
					<div v-if="ktpPreview" class="mt-3">
						<img :src="ktpPreview" alt="Preview KTP" class="img-thumbnail" style="max-width: 300px;">
					</div>
				</div>
			</div>

			<div class="alert alert-warning mt-4" role="alert">
				<i class="bx bx-error me-2"></i>
				<strong>Peringatan:</strong> Pastikan semua data yang Anda masukkan sudah benar.
				Proses pencairan akan dilakukan ke rekening yang Anda daftarkan di sini dan akan memakan waktu kurang lebih 3 bulan.
			</div>

			<div class="text-end mt-4">
				<button type="submit" class="btn btn-primary" :disabled="submitting">
					<i class="bx bx-save me-2"></i>
				{{ submitting ? (isEdit ? 'Mengupdate...' : 'Mengirim...') : (isEdit ? 'Update Form' : 'Submit Form Tutup Akun') }}
				</button>
			</div>
		</form>
	</div>
</template>

<script>
import { endpoint, host } from "../../../host";
import httpService from "../../../services/http-service";
import errorService from '../../../services/error-service';
import globalService from '../../../services/global-service';

export default {
	props: {
		submitting: {
			type: Boolean,
			default: false
		},
		closeAccountData: {
			type: Object,
			default: null
		},
		isEdit: {
			type: Boolean,
			default: false
		}
	},

	emits: ['submit'],

	mounted() {
		if (this.isEdit && this.closeAccountData) {
			// Mode edit - load existing data
			this.loadExistingData();
		} else if (this.closeAccountData) {
			// Create new but has close account data (shouldn't happen)
			this.loadExistingData();
		} else {
			// Create new - get form data from API
			this.getFormData();
		}
		this.getAccountInfo();
	},

	data() {
		return {
			formData: {
				name: '',
				address: '',
				nik: '',
				phone_number: '',
				bank_name: '',
				bank_account_number: '',
				bank_account_name: '',
			},
			ktpFile: null,
			ktpPreview: null,
			accountInfo: null,
			errors: {}
		};
	},

	methods: {
		loadExistingData() {
			if (this.closeAccountData) {
				this.formData = {
					name: this.closeAccountData.name,
					address: this.closeAccountData.address,
					nik: this.closeAccountData.nik,
					phone_number: this.closeAccountData.phone_number,
					bank_name: this.closeAccountData.bank_name,
					bank_account_number: this.closeAccountData.bank_account_number,
					bank_account_name: this.closeAccountData.bank_account_name,
				};
				// Set existing KTP preview
				if (this.closeAccountData.ktp_image) {
					this.ktpPreview = `${host}/storage/uploads/close_account/${this.closeAccountData.ktp_image}`;
				}
			}
		},

		async getFormData() {
			try {
				let res = await httpService.get(endpoint['close.account.form-data']);
				if (res.data.data) {
					this.formData = { ...res.data.data };
				}
			} catch (error) {
				// Ignore error, user will fill manually
			}
		},

		async getAccountInfo() {
			try {
				let res = await httpService.get(endpoint['close.account.account-info']);
				if (res.data.data) {
					this.accountInfo = res.data.data;
				}
			} catch (error) {
				errorService.displayError(error.response);
			}
		},

		handleFileChange(event) {
			const file = event.target.files[0];
			if (file) {
				this.ktpFile = file;
				// Create preview
				const reader = new FileReader();
				reader.onload = (e) => {
					this.ktpPreview = e.target.result;
				};
				reader.readAsDataURL(file);
			} else {
				this.ktpFile = null;
				this.ktpPreview = null;
			}
		},

		submitForm() {
			this.errors = {};
			
			// Create FormData for file upload
			const formData = new FormData();
			formData.append('name', this.formData.name);
			formData.append('address', this.formData.address);
			formData.append('nik', this.formData.nik);
			formData.append('phone_number', this.formData.phone_number);
			formData.append('bank_name', this.formData.bank_name);
			formData.append('bank_account_number', this.formData.bank_account_number);
			formData.append('bank_account_name', this.formData.bank_account_name);
			
			if (this.ktpFile) {
				formData.append('ktp_image', this.ktpFile);
			}

			this.$emit('submit', formData);
		},

		formatCurrency(value) {
			return globalService.toIdr(value);
		}
	}
};
</script>
